import { type StateCreator } from "zustand";

/**
 * Session actor context: "org" = member working inside an active org;
 * "field" = registered field tester working cross-org (no org switcher).
 */
export type ActorMode = "org" | "field";

export interface OrgState {
  activeOrgId: string | null;
  activeOrgRole: string | null;
  activeOrgName: string | null;
  activeOrgSlug: string | null;
  activeOrgRequireMfa: boolean;
  orgResolved: boolean;
  actorMode: ActorMode;
  isFieldActor: boolean;
}

export interface OrgActions {
  setActiveOrg: (
    orgId: string | null,
    orgRole: string | null,
    orgName: string | null,
    orgSlug: string | null,
    requireMfa?: boolean,
  ) => void;
  clearActiveOrg: () => void;
  setOrgResolved: (resolved: boolean) => void;
  setActorMode: (mode: ActorMode) => void;
  setIsFieldActor: (isFieldActor: boolean) => void;
}

export type OrgSlice = OrgState & OrgActions;

export const createOrgSlice: StateCreator<OrgSlice, [], [], OrgSlice> = (set) => ({
  activeOrgId: null,
  activeOrgRole: null,
  activeOrgName: null,
  activeOrgSlug: null,
  activeOrgRequireMfa: false,
  orgResolved: false,
  actorMode: "org",
  isFieldActor: false,
  setActiveOrg: (orgId, orgRole, orgName, orgSlug, requireMfa) =>
    set({
      activeOrgId: orgId,
      activeOrgRole: orgRole,
      activeOrgName: orgName,
      activeOrgSlug: orgSlug,
      activeOrgRequireMfa: requireMfa ?? false,
      orgResolved: true,
    }),
  clearActiveOrg: () =>
    set({
      activeOrgId: null,
      activeOrgRole: null,
      activeOrgName: null,
      activeOrgSlug: null,
      activeOrgRequireMfa: false,
      orgResolved: false,
      actorMode: "org",
      isFieldActor: false,
    }),
  setOrgResolved: (resolved) => set({ orgResolved: resolved }),
  setActorMode: (mode) => set({ actorMode: mode }),
  setIsFieldActor: (isFieldActor) => set({ isFieldActor }),
});
